var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper-slide",style:(("background-image: url(" + _vm.dataUrl + ")"))})}
var staticRenderFns = []

export { render, staticRenderFns }